import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Add icon — plus sign.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const AddIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M9.5 16V10.5H4C3.72386 10.5 3.5 10.2761 3.5 10C3.5 9.72386 3.72386 9.5 4 9.5H9.5V4C9.5 3.72386 9.72386 3.5 10 3.5C10.2761 3.5 10.5 3.72386 10.5 4V9.5H16C16.2761 9.5 16.5 9.72386 16.5 10C16.5 10.2761 16.2761 10.5 16 10.5H10.5V16C10.5 16.2761 10.2761 16.5 10 16.5C9.72386 16.5 9.5 16.2761 9.5 16Z"
      fill="currentColor"
    />
  </svg>
);

export default AddIcon;
